import React from 'react';

const NewsletterSubscriptionConfirm = props => {
  return (
    <div className="newsletter-subscription__panel">
      <h3 className="newsletter-subscription__title">{props.resourcedTexts.thankYouTitle}</h3>
      <p>{props.resourcedTexts.thankYouText}</p>
    </div>
  )
}

export default NewsletterSubscriptionConfirm;